import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, SimpleChanges } from '@angular/core'
import { DbService } from '../../services/db.service'
import IntervalTree from 'node-interval-tree'
import { Subscription } from 'rxjs'
import notify from 'devextreme/ui/notify'
import * as uuid from 'uuid/v1'
import * as moment from 'moment'

@Component({
  selector: 'app-booking-rest',
  templateUrl: './booking-rest.component.html',
  styleUrls: ['./booking-rest.component.css']
})
export class BookingRestComponent implements OnInit {

  @Input() booking;
  @Input() bookings;
  @Input() bookingObjects;
  @Input() combinations;
  @Input() webBlocks;
  @Input() shifts;
  @Input() ai;
  @Input() tags;

  @Output() addBi = new EventEmitter();

  @ViewChild('tiddiv') tiddiv: ElementRef;

  antal = 0
  duration = 0
  slots = []
  combcomb = []
  showTid = false
  calShifts = []

  busSubscription: Subscription

  queuePopupVisible = false
  queuePhone = ''
  queueSlot

  constructor(public db: DbService) {

    this.busSubscription = this.db.msgBusGetMessage().subscribe(message => {

      //if (this.db.debug) console.log("booking-grid msgBus incoming message", message);

      if (message.text == "calchange") setTimeout(() => { 
        this.antal = 0
        this.createSlots() 
      }, 200)

      if (message.text == "cancel") {
        this.antal = 0
        this.createSlots()
      }

    })
  }

  ngOnInit() {
    //setTimeout(() => {
    //  this.createSlots()
    //}, 250)
    
  }

  ngOnChanges(changes: SimpleChanges) {
    setTimeout(() => { 
      this.antal = 0
      this.createSlots()
    }, 200)
  }

  antalChange() {
    
    if (this.ai.resource.isrestaurant) this.booking.persons = +this.antal

    // Remove existing items if any
    this.booking.bookingItems = this.booking.bookingItems.filter(bi => bi.idResource != this.ai.resource.id)
    this.booking.tags = []
    this.addBi.emit()
    this.db.collapseBookingItems(this.booking, this.bookingObjects)

    // Set duration 
    this.showTid = true
    this.duration = +this.ai.resource.defaultduration
    this.ai.resource.durations.forEach(d => {
      if (+this.antal >= d.from && +this.antal <= d.to) this.duration = +d.duration
      if (d.from != 0 || d.to != 0) this.showTid = false
    })

    this.createSlots()
    this.checkAvailable()

    if (!this.ai.resource.durations.length) setTimeout(() => {
      this.tiddiv.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" })
    }, 600)

  }

  getRange(i) {
    var x = []
    if (this.ai.resource.name == 'Frallor') {
      for (var n = 1; n <= 20; n++) x.push(n * 10)
    } else {
      for (var n = 1; n <= i; n++) x.push(n)
    }
    
    return x
  }

  durationChange() {
    //console.log('durationChange', this.duration)
    
    this.createSlots()
    this.checkAvailable()

    setTimeout(() => {
      this.tiddiv.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" })
    }, 600)

  }

  createSlots() {

    this.slots = []
    this.calShifts = [{ id: '', name: ''}]
    //console.log('Creating slots in', this.ai.resource.name, this.ai.open)

    for (var i = this.ai.open; i <= +this.ai.close - +this.duration; i += +this.ai.resource.interval) {

      var duration = +this.duration
      if (this.ai.resource.durationRules) duration = this.db.getDuration(this.ai.resource, this.antal, i, this.db.workday)

      var tagId = ''

      this.shifts.filter(shift => shift.idResource == this.ai.resource.id).forEach(shift => {
        if (i >= shift.start && i < shift.start + shift.duration) {
          duration = shift.defaultduration
          this.tags.filter(t => t.name.toLowerCase() == shift.name.toLowerCase()).forEach(t => {
            tagId = t.id
          })
        }
      })

      this.slots.push({ 
        start: i, 
        available: false, 
        selected: false, 
        api: 0, 
        ppi: 0,
        totpersons: 0,
        duration: duration,
        tagId: tagId,
        availables: [] })
    }

    if (this.ai.resource.idcalendar) {
      
      //console.log(this.ai.resource.name, 'has calendar')
      
      let rules = this.db.getCalRules(this.ai.resource.idcalendar, this.db.workday)

      console.log('Cal rules', rules)

      this.slots = []
      this.calShifts = []

      if (!rules.closed) rules.bookableTimes.sort(this.db.sortOrderFunc).forEach(bt => {

        for (var n = bt.start; n <= bt.end - (bt.duration || this.ai.resource.defaultduration); n += bt.interval || this.ai.resource.interval) {
          let duration = bt.duration || this.db.getDuration(this.ai.resource, this.antal, i, this.db.workday)
          this.slots.push({ start: n, available: false, availables: [], selected: false, api: 0, ppi:0, reasons: [], duration: duration, idShift: bt.id, karens: bt.karens, calApi: bt.api, calPpi: bt.ppi, stopTime: bt.stopTime })
        }

        if (rules.shifts) this.calShifts.push({ id: bt.id, name: bt.name })

      })

      if (!this.calShifts.length) this.calShifts.push({ id: '', name: '' })
      

    }

    this.combcomb = []
    // Kombinera kombinationer och bokningsbara bokningsobjekt
    this.combcomb = this.combinations.filter(c => c.idResource == this.ai.resource.id && c.webbookable)
    this.bookingObjects.filter(bo => bo.idResource == this.ai.resource.id && bo.webbookable).forEach(bo => {
      this.combcomb.push({id: bo.id, name: bo.name, bookingObjects: [{id: bo.id, sortorder: 0}], seats: bo.seats, minseats: bo.minseats, idResource: bo.idResource, prio: bo.prio, zone: bo.zone, zones: bo.zones, deleted: false, sortorder: bo.sortindex})
    })
    this.combcomb.sort(function(a, b) {
      if (+a.prio < +b.prio) return -1;
      if (+a.prio > +b.prio) return 1;
      return 0;
    });    

  }

  checkAvailable() {

    // Skapa ivt
    var ivt = new IntervalTree()
    this.bookings.forEach(b => {
      b.bookingItems.filter(bi => bi.idResource == this.ai.resource.id).forEach(bi => {
        //if (bi.start + bi.duration - 1 > bi.start) ivt.insert(bi.start, bi.start + bi.duration - 1, bi.idBookingObject)
        if (bi.start + bi.duration - 1 > bi.start) ivt.insert(bi.start, bi.start + bi.duration + +this.ai.resource.cleaningtime - 1, bi.idBookingObject)
      })
    })

    // Testa varje slot
    this.slots.forEach(slot => {

      // Nollställ slot
      slot.selected = false
      slot.available = true; 
      slot.availables = []; 
      slot.api = 0; 
      slot.ppi = 0;
      slot.reason = 0;

      this.webBlocks.filter(wb => wb.idResource == this.ai.resource.id && wb.time == slot.start).forEach(wb => { slot.available = false; slot.reason = 1; })
      
      //if (slot.start == 1020) console.log('-1', slot.available)

      if (this.db.isToday()) {
        var d = new Date()
        var currentMinute = d.getHours() * 60 + d.getMinutes()
        var karens = +this.db.setting.karens    
        if (this.ai.resource.webkarens) karens = this.ai.resource.webkarens
        if (slot.karens) karens = slot.karens
        //console.log('==>', slot.start, karens)
        if (slot.start < currentMinute + karens) { slot.available = false; slot.reason = 2; }
        let webstop = this.db.setting.webstop * 60
        if (this.ai.resource.webstop) webstop = this.ai.resource.webstop
        if (slot.stopTime) webstop = slot.stopTime
        if (webstop && currentMinute > webstop) { slot.available = false; slot.reason = 3; }
      }

     // if (slot.start == 1020) console.log('-2', slot.available)

      // Check if arrivals per interval (api) or persons per interval (ppi) is reached
      if (this.ai.resource.isrestaurant) {
        this.bookings.forEach(b => {
          var nybokn = true;
          b.bookingItems.filter(bi => bi.idResource == this.ai.resource.id && bi.start == slot.start).forEach(bi => {
            var persons = +b.persons
            if (typeof bi.persons !== 'undefined') persons = +bi.persons
            //console.log(b.id, b.persons, bi.persons, persons)
            //slot.ppi += +persons
            if (nybokn) {
              slot.api++;
              slot.ppi += +b.persons
              nybokn = false;
            }
          });
        });
      }

      // Testa alla kombinationer som har rätt antal platser
      this.combcomb.filter(c => +this.antal >= +c.minseats && +this.antal <= +c.seats).forEach(c => {

        var available = true;
        
        // Testa alla obj i kombinationen var för sig
        c.bookingObjects.forEach(t => {
          
          // Kolla om bokning existerar på denna interval.
          //if (ivt.search(slot.start, +slot.start + +this.ai.resource.defaultduration - 1).filter(i => i == t.id).length) {
            if (ivt.search(slot.start, +slot.start + +slot.duration + +this.ai.resource.cleaningtime - 1).filter(i => i == t.id).length) {
            available = false;
          }

        });

        // Om fortfarande available o...
        if (available) slot.availables.push(c.id)

      })

      //if (slot.start == 1020) console.log('0', slot.available)

      // To many arrivals at slot?
      let api = this.ai.resource.api
      if (slot.calApi) api = slot.calApi
      if (slot.api + 1 > api) {
        slot.available = false
        slot.reason = 4
      }
      
      //if (slot.start == 1020) console.log('1', slot.available)
      
      // To many persons at slot?
      let ppi = this.ai.resource.ppi
      if (slot.calPpi) ppi = slot.calPpi
      if (slot.ppi + +this.antal > ppi) {
        slot.available = false
        slot.reason = 5
      }      

      //if (slot.start == 1020) console.log('2', slot.available)

      // No bookingobjects available
      if (!slot.availables.length) {
        slot.available = false
        slot.reason = 6
      }      

      //if (slot.start == 1020) console.log('3', slot.available)

      if (this.db.system == 'norika' && this.antal >= 5 && [1040, 1060, 1200, 1220].includes(slot.start)) slot.available = false

    })

  }

  slotClick(s) {
    
    // Red slot clicked
    if (!s.available) {
      this.askQueue(s)
      return
    }

    // Special for cust Enoteket to fit in iframe on mobile
    if (this.db.system.toLowerCase() == 'enoteket') this.db.panel1Expanded = false

    // Check for overlaps within own booking
    var ivt = new IntervalTree()
    this.booking.bookingItems.filter(bi => bi.idResource != this.ai.resource.id).forEach(bi => {
      if (bi.start + bi.duration - 1 > bi.start) ivt.insert(bi.start, bi.start + bi.duration - 1, bi.idBookingObject)
    })
    if (ivt.search(s.start, s.start + s.duration - 1).length) {
      notify('Vald tid överlappar annan aktivitet', 'error', 2000)
      return
    }
    
    // Remove possible other items in this resource and collapse
    this.booking.bookingItems = this.booking.bookingItems.filter(bi => bi.idResource != this.ai.resource.id)
    this.booking.tags = []
    this.addBi.emit()
    this.db.collapseBookingItems(this.booking, this.bookingObjects)

    if (s.selected) {
      
      // Unmark
      s.selected = false

    } else {

      // Unmark others and mark selected slot
      this.slots.forEach(s => s.selected = false)
      s.selected = true
      
      // Add tag from Shift
      if (s.tagId) this.booking.tags.push(s.tagId)

      // Add first combcomb to booking
      this.combcomb.filter(c => c.id == s.availables[0]).forEach(c => {
        
        c.bookingObjects.forEach(bo => {

          this.booking.bookingItems.push({
            id: uuid(),
            idBookingObject: bo.id,
            idResource: this.ai.resource.id,
            idEvent: '',
            start: s.start,
            duration: s.duration,
            status: 0,
            persons: this.ai.resource.isrestaurant ? this.antal : 0,
            price: 0,
            vat: 0
          })

        })
      })

      this.addBi.emit()
      this.db.collapseBookingItems(this.booking, this.bookingObjects)

      this.db.msgBusSendMessage('sammanst')

    }
    
  }

  askQueue(s) {
    //console.log('Queue')
    if (!this.db.setting.enableQueue) return
    this.queueSlot = s
    this.queuePopupVisible = true
  }

  queueOk() {

    this.queuePopupVisible = false

    //console.log(this.queuePhone, this.queueSlot, this.ai)

    if (this.queuePhone) this.db.sendMessagePromise('msave', { table: 'bookingqueues', system: this.db.system, data: { 
      id: uuid(),
      system: this.db.system,
      workday: this.db.workday,
      persons: this.antal,
      idResource: this.ai.id,
      start: this.queueSlot.start,
      duration: this.queueSlot.duration,
      phone: this.queuePhone,
      ts: moment().format('YYYY-MM-DD HH:mm:ss')
    } })

  }
  

}

//